<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records upload-dna-section">
            <div class="row h-100">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body p-0">
                            <div class="bg-white border-radius-5 p-5">
                                <div class="row no-gutters justify-content-center">
                                    <div class="col-md-6 text-center upload-reports">
                                        <form class="mt-1">
                                            <div class="securely-uploa mb-3 p-3">
                                                <h2>Securely upload your data</h2>
                                                <p>We prefer .TXT files. If you encounter a problem uploading your zip file, please extract the zip and try again with the text file.</p>
                                            </div>
                                            <div class="drag-drop">
                                                <input type="file" multiple />
                                                <i class="icon icon-upload-reports"></i>
                                                <h3 class="mt-4">Drag and Drop Files Files To Upload</h3>
                                                <p>you can do this anytime without clicking upload</p>
                                                <span class="d-block">or</span>
                                                <button type="submit" class="btn btn-blue attach">Attach File</button>
                                            </div>
                                            <div class="file-size">
                                                <p>Maximum Upload File Size: 25MB</p>
                                            </div>
                                            <div class="preview">
                                                <h4 class="mt-4 mb-3 text-center">Uploading</h4>
                                                <div class="file-upload d-flex justify-content-between align-items-center border-radius-5 border-1 bg-white mb-4 p-2">
                                                    <div class="image-upload d-flex align-items-center">
                                                        <figure class="mb-0"><img src="../../../../static/website/images/report.png" alt="" /></figure>
                                                        <h5>Tab-interaction.pdf</h5>
                                                    </div>
                                                    <div class="icons d-fle">
                                                        <a href="#"><i class="icon icon-check-bold"></i></a>
                                                        <a href="#" class="close-icon"><i class="icon icon-close"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <router-link to="/dna-success" class="btn btn-blue">Finish</router-link >
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "dna-test-reports",
        data() {
            return {};
        },
        created(){
           this.pageName('DNA Test Reports')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/dna/dna-test-reports.vue